import { render } from "./DetailModalInfo.vue?vue&type=template&id=652694fc&scoped=true"
import script from "./DetailModalInfo.vue?vue&type=script&lang=js"
export * from "./DetailModalInfo.vue?vue&type=script&lang=js"

import "./DetailModalInfo.vue?vue&type=style&index=0&id=652694fc&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652694fc"]])

export default __exports__